/*
 *
 * ForgotPasswordPage actions
 *
 */

import {
  PASSWORD_RESET_REQUEST,
  PASSWORD_RESET_SUCCESS,
  PASSWORD_RESET_FAILURE,
  PASSWORD_RESET_REQUEST_REQUEST,
  PASSWORD_RESET_REQUEST_SUCCESS,
  PASSWORD_RESET_REQUEST_FAILURE,
  REQUEST_ANOTHER,
  SET_COMPONENT_TO_RENDER,
  PASSWORD_RESET_FORM,
  RESET_FORGOT_PASSWORD_STATE,
  INVALID_PASSWORD_RESET_FORM
} from './constants';

export const passwordResetRequest = (payload) => ({
  type: PASSWORD_RESET_REQUEST,
  payload
});

export const resetForgotPageState = (payload) => ({
  type: RESET_FORGOT_PASSWORD_STATE,
});


export const passwordResetSuccess = () => ({
  type: PASSWORD_RESET_SUCCESS,
});

export const passwordResetFailure = () => ({
  type: PASSWORD_RESET_FAILURE,
});

export const passwordResetRequestRequest = (payload) => ({
  type: PASSWORD_RESET_REQUEST_REQUEST,
  payload
});

export const passwordResetRequestSuccess = () => ({
  type: PASSWORD_RESET_REQUEST_SUCCESS,
});

export const passwordResetRequestFailure = () => ({
  type: PASSWORD_RESET_REQUEST_FAILURE,
});

export const requestAnother = () => ({
  type: REQUEST_ANOTHER,
});

export const setComponentToPasswordReset = () => ({
  type: SET_COMPONENT_TO_RENDER,
  payload: PASSWORD_RESET_FORM
});

export const setComponentToInvalidPasswordReset = () => ({
  type: SET_COMPONENT_TO_RENDER,
  payload: INVALID_PASSWORD_RESET_FORM
});



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/actions.js